import { IconFn, IconSvg } from "../createIcon";

export const CopyIcon: IconFn = ({ color = "#050203", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 16, height: 15 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.844.813c-.381 0-.747.148-1.017.411a1.39 1.39 0 0 0-.42.995v1.406h1.437V2.219h7.906v7.734h-1.438v1.406h1.438c.381 0 .747-.148 1.017-.412.269-.263.42-.62.42-.994V2.22c0-.373-.151-.73-.42-.995A1.454 1.454 0 0 0 13.75.813H5.844ZM2.25 4.328c-.381 0-.747.148-1.016.412a1.39 1.39 0 0 0-.421.994v7.735c0 .373.151.73.42.994.27.264.636.412 1.017.412h7.906c.381 0 .747-.148 1.017-.412a1.39 1.39 0 0 0 .42-.994V5.734c0-.373-.15-.73-.42-.994a1.454 1.454 0 0 0-1.017-.412H2.25Zm0 1.406h7.906v7.735H2.25V5.734Z"
      fill={color}
    />
  </IconSvg>
);
